export const Locales = [
    { value: "en", text: "English" },
    { value: "fr", text: "Français" }
]